<template>
    <BaseView :ignoreOffline="true">
        <template v-slot:top>
            <TopNavigation />
            <inspection-count
                v-if="isOnFreePlan"
                :user="user"
            />
        </template>

        <div v-if="drafts.length === 0" class="middle-of-page">
            {{ $t("There are no started inspections.") }}
        </div>

        <template v-for="draft in drafts">
            <Draft
                :key="draft.id"
                :draft="draft"
                @click.native="openDetailsModal(draft)"
                />
        </template>

        <template v-slot:bottom>
            <bottom-navigation />
        </template>

        <portal to="modals">
            <transition name="fade">
                <DraftDetailsModal
                    v-if="detailsModalOpen"
                    :draft="selectedDraft"
                    @resumeDraft="resumeDraft"
                    @deleteDraft="deleteDraft"
                    @close="closeDetailsModal"
                />
            </transition>
        </portal>
    </BaseView>
</template>

<script>
import { mapGetters } from 'vuex';
import Draft from '@mobile/views/Checklists/Items/Draft.vue';
import DraftDetailsModal from '@mobile/views/Checklists/Modals/DraftDetails.vue';
import InspectionCount from '@mobile/components/InspectionCount.vue';
import TopNavigation from '@mobile/views/Checklists/components/Navigation';
import BaseView from '@mobile/components/BaseView.vue';
import OnFreePlan from '@mobile/mixins/OnFreePlan';
import { eventBus } from '@/eventBus';

export default {
    components: {
        Draft, DraftDetailsModal, TopNavigation, BaseView, InspectionCount,
    },

    mixins: [
        OnFreePlan,
    ],

    data: () => ({
        detailsModalOpen: false,
        selectedDraft: null,
    }),


    computed: {
        ...mapGetters({
            drafts: 'drafts/all',
        }),
    },

    created() {
        this.$store
            .dispatch('drafts/loadFromDB')
            .then(() => {
                eventBus.$emit('loaded');
            }).catch((error) => {
                eventBus.$emit('client-error', error);
            });
    },

    methods: {
        openDetailsModal(draft) {
            this.selectedDraft = draft;
            this.detailsModalOpen = true;
        },

        closeDetailsModal() {
            this.detailsModalOpen = false;
            this.selectedDraft = null;
        },

        resumeDraft() {
            this.$router.push({
                name: 'conduct',
                params: {
                    resourceId: this.selectedDraft.id,
                    type: 'draft',
                },
            });

            this.closeDetailsModal();
        },

        async deleteDraft() {
            if (this.selectedDraft.todo) {
                await this.$store.dispatch('todos/detachDraft', this.selectedDraft.todo);
            }

            await this.$store.dispatch('drafts/delete', this.selectedDraft.id);

            this.closeDetailsModal();

            this.$toasted.show(
                this.$t('The draft was deleted!'),
                { type: 'success' },
            );
        },
    },
};

</script>
